export const WHATSAPP_NUMBER = "+61 493 133 372";
export const INSTAGRAM_HANDLE = "@festivetheory";
export const INSTAGRAM_URL = "https://instagram.com/festivetheory";

export const wa = (message) =>
    `https://wa.me/61493133372?text=${encodeURIComponent(message)}`;

export const WA_DEFAULT = wa(
    "Hi Festive Theory! I'd love to enquire about your collection."
);

export const nav = { lenis: null };

export const scrollToId = (id) => {
    const el = document.querySelector(id);
    if (!el) return;
    if (nav.lenis) {
        nav.lenis.scrollTo(el, { offset: -72, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};
